<template>
  <div class="lang-toggle" role="group" aria-label="Language Switcher">
    <button
      class="chip"
      :class="{ active: locale === 'tr' }"
      @click="change('tr')"
      :aria-pressed="locale === 'tr'"
      type="button"
    >
      <span class="code">TR</span>
    </button>
    <button
      class="chip"
      :class="{ active: locale === 'en' }"
      @click="change('en')"
      :aria-pressed="locale === 'en'"
      type="button"
    >
      <span class="code">EN</span>
    </button>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { setLocale } from '../i18n'
import { useRoute } from 'vue-router'
import { useAuthStore } from '@/store/auth'
import { useMissionStore } from '@/store/mission'
import { useTimeStore } from '@/store/time'
import { useAchievementsStore } from '@/store/achievements'
import { useDonatedStore } from '@/store/donated'

const AUTH_ROUTE_NAMES = new Set([
  'login',
  'register',
  'forgot-password',
  'new-password',
  'activate-user',
  'on-google-auth'
])

const { locale } = useI18n()
const route = useRoute()
const authStore = useAuthStore()
const missionStore = useMissionStore()
const timeStore = useTimeStore()
const achievementsStore = useAchievementsStore()
const donatedStore = useDonatedStore()

async function change (val) {
  if (locale.value === val) return
  locale.value = val
  setLocale(val)

  if (AUTH_ROUTE_NAMES.has(route.name)) {
    return
  }

  // Refresh server-backed data to reflect new locale without a full reload
  if (authStore.isLoggedIn) {
    try { timeStore.getTimeList() } catch (_) {}
  }

  try {
    if (route.name === 'duties' || route.name === 'home' || route.name === 'home-map') {
      await missionStore.getMyMissionList()
      await missionStore.getMissions()
    }
    // Yeniden açık olan detay popup’ı güncelle (route’tan bağımsız)
    if (missionStore.selectedMissionId && missionStore.selectedLocationId) {
      missionStore.getSelectedMissionId(missionStore.selectedMissionId, missionStore.selectedLocationId)
    } else if (missionStore?.missionsDetail?.mission?.mission?.id && missionStore?.missionsDetail?.location?.id) {
      missionStore.getSelectedMissionId(
        missionStore.missionsDetail.mission.mission.id,
        missionStore.missionsDetail.location.id
      )
    }
  } catch (_) {}

  try {
    if (route.name === 'achievements') {
      achievementsStore.getAchievementsList()
      donatedStore.getDonatedList()
    }
  } catch (_) {}
}
</script>

<style scoped>
.lang-toggle {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px;
  border-radius: 999px;
  background: #ffffff;
  border: 1px solid #e6e9f2;
}

.chip {
  appearance: none;
  border: none;
  outline: none;
  cursor: pointer;
  background: transparent;
  color: #181818;
  font-weight: 600;
  font-size: 12px;
  line-height: 1;
  padding: 8px 12px;
  min-width: 44px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background-color 160ms ease, color 160ms ease, transform 120ms ease;
}

.chip:active { transform: scale(0.98); }

.chip.active {
  background: var(--brand-color); /* project accent */
  color: #ffffff;
}

.code { letter-spacing: 0.3px; }
</style>
